/**
 * Подпись в шапке терминала: TelegramBots (статично) + только формат .js печатается и стирается.
 */

import { useState } from "react";
import Typewriter from "../Typewriter/Typewriter";

const LABEL_EXTENSIONS = [
    ".js", ".py", ".pyw", ".pyc", ".pyd", ".pyo", ".pyi", ".mjs", ".cjs", ".jsx",
    ".ts", ".tsx", ".d.ts", ".php", ".php3", ".php4", ".php5", ".php7", ".phtml",
    ".java", ".class", ".jar", ".cs", ".csx", ".go", ".rb", ".rbw", ".rake", ".gemspec",
    ".rs", ".rlib", ".kt", ".kts", ".swift", ".cpp", ".cc", ".cxx", ".c++", ".c",
    ".h", ".hh", ".hpp", ".hxx", ".h++", ".scala", ".sc", ".dart", ".ex", ".exs",
    ".hs", ".lhs", ".clj", ".cljs", ".cljc", ".edn", ".lua", ".pl", ".pm", ".pod", ".t",
    ".r", ".R", ".Rmd", ".sh", ".bash", ".zsh", ".fish", ".ksh", ".csh",
    ".vb", ".vbs", ".vba", ".fs", ".fsx", ".fsi", ".m", ".mm", ".groovy", ".gvy", ".gy", ".gsh",
    ".cr", ".nim", ".nimble", ".jl", ".erl", ".hrl", ".elm", ".purs", ".rkt", ".scm", ".ss", ".sls",
    ".lisp", ".lsp", ".cl", ".el", ".coffee", ".litcoffee", ".re", ".rei", ".ml", ".mli", ".mll", ".mly",
    ".pas", ".pp", ".inc", ".dpr", ".asm", ".s", ".for", ".f", ".f90", ".f95", ".f03", ".f08",
    ".cob", ".cbl", ".cpy", ".ada", ".adb", ".ads", ".d", ".di", ".v", ".sv", ".svh", ".vhd", ".vhdl",
    ".tcl", ".tk", ".awk", ".sed", ".bat", ".cmd", ".ps1", ".psm1", ".psd1", ".vim", ".vimrc",
    ".sql", ".mysql", ".pgsql", ".sqlite", ".plsql", ".ddl", ".dml", ".pro", ".P", ".ecl", ".zig",
    ".odin", ".v", ".vlang", ".hack", ".hh", ".bal", ".coq", ".agda", ".idr", ".raku", ".rakumod", ".p6", ".pl6", ".nqp",
    ".carp", ".pony", ".red", ".reds", ".ring", ".wren", ".io", ".factor", ".forth", ".fth", ".monkey", ".monkey2",
    ".x10", ".ceylon", ".fan", ".boo", ".cobra", ".vala", ".vapi", ".genie", ".xtend",
];

function TerminalLabel({ startAfter = false }) {
    const [phase, setPhase] = useState("erasing");
    const [index, setIndex] = useState(0);
    const ext = LABEL_EXTENSIONS[index];

    if (!startAfter) {
        return <>TelegramBots{LABEL_EXTENSIONS[0]}</>;
    }

    if (phase === "typing") {
        return (
            <>
                TelegramBots
                <Typewriter
                    key={`t-${index}`}
                    text={ext}
                    speed={120}
                    delay={400}
                    onComplete={() => setPhase("erasing")}
                />
            </>
        );
    }

    return (
        <>
            TelegramBots
            <Typewriter
                key={`e-${index}`}
                reverse
                fullText={ext}
                targetText=""
                speed={90}
                delay={600}
                onComplete={() => {
                    setIndex((i) => (i + 1) % LABEL_EXTENSIONS.length);
                    setPhase("typing");
                }}
            />
        </>
    );
}

export default TerminalLabel;
